module.exports = __webpack_public_path__ + "img/palmtal1.76733be3.png";